/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Global
import { Text } from '@sitecore-content-sdk/nextjs';
import { withStandardComponentWrapper } from 'helpers/HOC';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import LinkWrapper from 'helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import { getTestProps } from 'lib/testing/utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const CustomFormDefaultComponent = (props)=>/*#__PURE__*/ _jsx("div", {
        className: `component card ${props?.params?.styles}`,
        children: /*#__PURE__*/ _jsx("div", {
            className: "component-content",
            children: /*#__PURE__*/ _jsx("span", {
                className: "is-empty-hint",
                children: "CustomForm"
            })
        })
    });
const CustomForm = (props)=>{
    const isEditing = useIsEditing();
    const id = props?.params?.RenderingIdentifier;
    if (props?.fields) {
        return /*#__PURE__*/ _jsx("section", {
            className: `card ${props?.params?.styles}`,
            id: id ? id : undefined,
            ...getTestProps(`component-contact-form-${props?.rendering?.uid}`),
            children: /*#__PURE__*/ _jsx("div", {
                className: "flex justify-center items-center",
                "data-component": "authorable/shared/other/customform",
                ...editingHydrationProps(isEditing),
                children: /*#__PURE__*/ _jsx("div", {
                    className: "mx-auto my-0",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "border border-gray",
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                field: props?.fields?.title,
                                tag: "h3",
                                ...getTestProps(`title`)
                            }),
                            /*#__PURE__*/ _jsx(RichTextWrapper, {
                                className: "text-gray text-base font-normal not-italic leading-6 mb-2 opacity-90",
                                field: props?.fields?.description,
                                tag: "div",
                                ...getTestProps(`description`)
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex gap-xxs flex-wrap justify-center md:justify-normal",
                                children: [
                                    /*#__PURE__*/ _jsx(LinkWrapper, {
                                        ctaComponentClass: "default",
                                        className: "flex items-center justify-center px-4 py-3 rounded bg-gray text-center text-white text-sm font-bold not-italic leading-normal",
                                        field: props?.fields?.primaryCTA,
                                        suppressNewTabIcon: true,
                                        ...getTestProps(`primary-cta`)
                                    }),
                                    /*#__PURE__*/ _jsx(LinkWrapper, {
                                        ctaComponentClass: "default",
                                        className: "flex items-center justify-center p-3 rounded border border-gray text-center text-gray text-base font-bold not-italic leading-normal",
                                        field: props?.fields?.secondaryCTA,
                                        suppressNewTabIcon: true,
                                        ...getTestProps(`secondary-cta`)
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        });
    }
    return /*#__PURE__*/ _jsx(CustomFormDefaultComponent, {
        ...props
    });
};
export const Default = withStandardComponentWrapper(CustomForm);
